import * as types from '../actions/types';


const initialState = {
  action: '',
  locale: '',
  queryString: '',
  suggestions: {},
};

export default function searchResultsReducer(state = initialState, action) {
  switch (action.type) {
    case types.RECEIVE_AUTO_SUGGESTIONS:
      return {
        ...state,
        ...action.search,
        suggestions: action.search.suggestions,
      };
    default:
      return state;
  }
}
